<div class="wrapper">
    <div class="centered">
        <mat-card class="cardContent">
            <div class="title">
                Maintenance Login
            </div>

            <button mat-raised-button class="logout" (click)="login()">Login</button>
        </mat-card> 
    </div>
</div>